<template>
  <v-card class="elevation-2">
    <v-card-text>
      <v-timeline align-top dense class="scroll-box">
          <v-timeline-item v-for="(movement, index) in movements" :key="index" :color="movement.estatus.color" small>
          <div>
              <div class="font-weight-normal">
                <v-chip :color="movement.estatus.color" label outlined>{{ movement.estatus.estatus }}</v-chip>
                @ <label class="font-weight-bold subtitle-2 text--primary">
                    {{ new Date(movement.created_at).toISOString().substr(0, 10) }}
                    {{ new Date(movement.created_at).toLocaleTimeString('it-IT') }}
                  </label>
              </div>
              <div v-if="movement.detalle" class="pl-1">
                <v-row dense>
                  <v-col v-for="(field, i) in movement.estatus.formulario.fields" :key="i"
                    :cols="field.cols" :offset="field.offset" :hidden="field.hidden">
                    <p class="font-italic ma-0" v-if="field.nameid == 'empleado_id'">
                        <span class="font-weight-bold font-weight-black"> {{ field.name }}:</span>
                        <span > {{ movement.detalle.descripcion[field.name.toLowerCase()].NombreCompleto }}</span>
                        <!-- <span v-if="movement.detalle.descripcion[field.name.toLowerCase()]">
                            {{ movement.detalle.descripcion[field.name.toLowerCase()] }}
                        </span>
                        <span v-else>{{ movement.detalle.descripcion[field.nameid.toLowerCase()] }}</span> -->
                    </p>
                  </v-col>
                </v-row>
              </div>
          </div>
          </v-timeline-item>
      </v-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'onSuccess'],
  data: () => ({
    movements: []
  }),
  components: {},
  created () {
    if (this.itemAction.url) { this.getDinamicData(this.itemAction.url) }
    // this.getDinamicData(this.itemAction.url)
  },
  methods: {
    getDinamicData (url) {
      const header = HeaderGral()
      axios.get(url, header).then((response) => {
        this.movements = []
        this.movements.push(...response.data)
      }).catch((error) => {
        if (error == null) console.log('Error')
      }).finally(() => {
      })
    }
  }
}
</script>

<style scoped>
.scroll-box {
  min-height: 300px;
  max-height: 1000px;
  width: 100%;
  overflow-x: auto;
}
</style>
